// Copyright (c) 2026 SoundDrift. All rights reserved.
//
// Scoring rules shared by the Worker (authoritative) and the frontend (display
// only). Kept here rather than duplicated: GifDrift copied utils across trees
// and they drifted apart, which is the exact failure this project's CLAUDE.md
// rule 7 exists to prevent.
//
// This module must stay dependency-free and browser-safe. The frontend used to
// import computeAuthorBonus straight out of cloudflare/src/modes/soundoff.js,
// which pulls in Node's `createRequire` and cannot bundle for a browser at all.

/**
 * Bonus awarded to a prompt's author, scaled by how contested the duel was.
 *
 * min(votesA, votesB) peaks when a duel splits evenly, so a prompt that both
 * answers landed on rewards its author more than a landslide does. That is the
 * intent from REQUIREMENTS 3.1: reward prompts that are hard to answer well,
 * not prompts that are merely provocative.
 */
export function computeAuthorBonus(votesA, votesB, multiplier = 100) {
  const countA = typeof votesA === 'number' ? votesA : 0;
  const countB = typeof votesB === 'number' ? votesB : 0;
  return Math.min(countA, countB) * multiplier;
}
